import {
  Button,
  CascaderField,
  Col,
  Form,
  Row,
  Space,
  SubmitButton,
  TextInputField,
} from '@/components';
import type { OrganizationTemplateSearchFormSchema } from '@/features/organization-template/_models/organization-template';
import { useOrganizationOptionsRecursive } from '@/features/tenant-manager/organization/_hooks/organization';
import type { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';

type FormValues = z.infer<typeof OrganizationTemplateSearchFormSchema>;

type Props = {
  resetFormValues: FormValues;
  onSearch: (values: FormValues) => void;
};

export const OrganizationTemplateSearchForm: FC<Props> = ({
  resetFormValues,
  onSearch,
}) => {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors },
    reset,
    handleSubmit,
  } = useFormContext<FormValues>();

  const organizationsOptions = useOrganizationOptionsRecursive();

  return (
    <Form
      leavePageAlertCondition={null}
      layout="vertical"
      onFinish={handleSubmit(onSearch)}
    >
      <Row gutter={[16, 0]}>
        <Col span={6}>
          <TextInputField
            name="q"
            label={t('organization-template.name')}
            control={control}
            errors={errors}
          />
        </Col>
        <Col span={6}>
          <CascaderField
            name="nestedOrganizationIds"
            label={t('organization-template.user-organizations')}
            control={control}
            options={organizationsOptions.data}
            multiple
            errors={errors}
          />
        </Col>
      </Row>
      <Space>
        <Button
          htmlType="button"
          type="default"
          onClick={() => {
            reset(resetFormValues);
          }}
        >
          {t('search-clear')}
        </Button>
        <SubmitButton text={t('search-by')} />
      </Space>
    </Form>
  );
};
